import React, { useState } from 'react';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { validateEmail } from '../../utility/form_utilities';
import { classNames } from '../../utility/utility';
import { Dialog } from 'primereact/dialog';

type ShareModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  itemToShare: string;
  onShare: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    Error,
    { id: string; email: string }
  >;
};

export const ShareModal = ({
  isOpen,
  onClose,
  id,
  itemToShare,
  onShare,
}: ShareModalProps) => {
  const [formData, setFormData] = useState({ id: id, email: null });
  const [isSharing, setIsSharing] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (isSharing) return;
    if (validateEmail(formData.email)) {
      setInvalidEmail(false);
    } else {
      setInvalidEmail(true);
      return;
    }

    setIsSharing(true);
    try {
      await onShare(formData);
      onClose();
    } finally {
      setIsSharing(false);
    }
  };

  return (
    <Dialog
      header={`Share ${itemToShare}`}
      visible={isOpen}
      style={{ width: '50vw', zIndex: 1000 }}
      onHide={onClose}
    >
      <div className="bg-white p-4 rounded-md" id="share-list-sort-form">
        <form>
          <div className="mb-4">
            {invalidEmail && (
              <span className="text-red-500">Please provide a valid email</span>
            )}
            <label
              htmlFor="name"
              className={classNames(
                'block text-gray-600 text-start',
                invalidEmail && 'text-red-500'
              )}
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              defaultValue={formData.email}
              placeholder="Enter the email you'd like to share with"
              onChange={handleInputChange}
              className={classNames(
                'w-full border rounded-md px-3 py-2',
                invalidEmail && 'border-red-500'
              )}
              required
            />
          </div>
        </form>
        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
            onClick={handleSubmit}
            disabled={false}
          >
            Share
          </button>
          <button
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};
